import { GetConstraintsResponse } from 'api/typegen/application/constraints/get';
import { QueryStatus, useQuery } from '@tanstack/react-query';
import getConstraintsApiCall from 'api/calls/getConstraintsApiCall';
import useAuth from './useAuth';

interface UseLoanConstraintsQuery {
  status: QueryStatus;
  loanConstraints?: GetConstraintsResponse;
}

const useLoanConstraintsQuery = (): UseLoanConstraintsQuery => {
  const { token } = useAuth();
  const query = useQuery(
    ['getConstraintsApiCall', token],
    getConstraintsApiCall,
    { staleTime: Infinity },
  );

  return {
    status: query.status,
    loanConstraints: query.data,
  };
};

export default useLoanConstraintsQuery;
